import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AppConfig } from '@shared/interfaces';
import { ConfigService, StorageService } from '@shared/services';
import { of } from 'rxjs';
import { map, catchError, tap, switchMap } from 'rxjs/operators';
import { load, loginSuccess, loginFailure } from './config.actions';
import { Device } from '@capacitor/device';

@Injectable()
export class ConfigEffects {

  login$ = createEffect(() =>
    this.actions$.pipe(
      ofType(load),
      switchMap(() =>
        this.configService.getConfig().pipe(
          tap(this.setDefaultLanguage.bind(this)),
          map(config => loginSuccess({ config })),
          catchError(error => of(loginFailure({ error })))
        )
      )
    )
  );

  private async setDefaultLanguage(config: AppConfig): Promise<void> {
    await this.storage.init();
    const currentlang = await this.storage.getItem('lang');
    if (!currentlang) {
      const { value } = await Device.getLanguageCode();
      let langKey = config.defaultLanguage;
      const nav = (value || navigator.language || '').toLowerCase().split('-');
      if (['pl', 'en'].includes(nav[0])) {
        langKey = nav[0];
      }
      await this.storage.setItem('lang', langKey);
    }
  }

  constructor(
    private actions$: Actions,
    private configService: ConfigService,
    private storage: StorageService
  ) {}

}
